import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { GridComponent, ColumnsDirective, ColumnDirective } from "@syncfusion/ej2-react-grids";
import { retrieveInvoiceList, updateInvoicePaymentStatus } from "../../api/PupilApi";
import { useNavigate } from "react-router-dom";
import { logo } from "../../assets/images";
import jsPDF from "jspdf";
import "jspdf-autotable";

const InvoicesPage = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [invoicesData, setInvoicesData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showPopup, setShowPopup] = useState(false);
    const [selectedInvoice, setSelectedInvoice] = useState(null);
    const [selectedStatus, setSelectedStatus] = useState("");
    const [amount, setAmount] = useState("");
    const [transactionId, setTransactionId] = useState("");
  
    useEffect(() => {
      //alert("State data received: " + JSON.stringify(location.state));
    }, [location.state]);
  
    const serializableProduct = location.state;
  
    useEffect(() => {
      const fetchInvoices = async () => {
        //alert("product data"+JSON.stringify(serializableProduct))
        if (!serializableProduct?.email) {
         // alert("No email provided in the state data.");
          setLoading(false);
          return;
        }
  
        try {
          const response = await retrieveInvoiceList(serializableProduct.email);
          setInvoicesData(response.data.data);
        } catch (error) {
          console.error("Error fetching invoice data:", error);
        } finally {
          setLoading(false);
        }
      };
  
      fetchInvoices();
    }, [serializableProduct]);
  
    const handleOpenPopup = (invoice) => {
      setSelectedInvoice(invoice);
      setSelectedStatus(""); // Reset selected status
      setAmount(""); // Reset amount
      setTransactionId(""); // Reset transaction ID
      setShowPopup(true);
    };
  
    // const handleClickBack = () => {
    //   navigate("/viewOrderList");
    // };
  
    const handleDownloadInvoice = (invoice) => {
      const doc = new jsPDF();
    
      // Add logo
      doc.addImage(logo, 'PNG', 10, 10, 30, 30); // Adjust x, y, width, height for your logo position and size
      
      // Add Company Address
      doc.setFontSize(10);
      doc.text('44, MECHERI, Kukkalpatti, Salem, Tamil Nadu, 636453', 10, 50);
      doc.text('GST: 33CTPPK9946M1ZQ, Phone: 04298-278160', 10, 60);
    
      doc.setFontSize(16);
      doc.text("Invoice", 90, 10);
    
      doc.setFontSize(12);
      doc.text(`Invoice Number: ${invoice.invoiceNumber}`, 10, 80);
      doc.text(`Invoice Date: ${invoice.invoiceDate}`, 10, 90);
  
      // Add new fields: gram, gstPercentage, and wastage
      doc.autoTable({
        startY: 160,
        head: [["Field", "Value"]],
        body: [
          ["Invoice Number", invoice.invoiceNumber],
          ["Invoice Date", invoice.invoiceDate],
         // ["Cost (Excluding GST)", `₹${invoice.costExcludingGstPay.toFixed(2)}`],
          ["Cost (Including GST)", `₹${invoice.costIncludingGstPay.toFixed(2)}`],
          ["Payment Status", invoice.paymentStatus],
          ["Gram", invoice.gram],
          ["GST Percentage", `${invoice.gstPercentage}%`],
          ["Wastage", `${invoice.wastage}%`],
          ["Pending Payment", `₹${invoice.pendingAmount.toFixed(2)}`],
        ],
      });
  
      doc.save(`Invoice_${invoice.invoiceNumber}.pdf`);
    };
  
    const handleStatusUpdate = async () => {
      //if (!selectedStatus || !amount || !transactionId) {
       // alert("Please fill in all fields: status, amount, and transaction ID.");
//return;
   //   }
  
      try {
        const response = await updateInvoicePaymentStatus(
          serializableProduct.email,
          selectedInvoice.invoiceNumber,
          selectedStatus,
          amount,
          transactionId,
          serializableProduct,
          
        );
  
        if (response.status === 200) {
         // alert("Payment status updated successfully!");
          setInvoicesData((prevData) =>
            prevData.map((invoice) =>
              invoice.invoiceNumber === selectedInvoice.invoiceNumber
                ? { ...invoice, paymentStatus: selectedStatus }
                : invoice
            )
          );
          setShowPopup(false); // Close the popup
        } else {
          //alert("Failed to update payment status.");
        }
      } catch (error) {
        console.error("Error updating payment status:", error);
        //alert("An error occurred while updating payment status.");
      }
    };
  
    return (
      <div>
        <h2>Invoices</h2>
        
        {loading ? (
  <p>Loading...</p>
) : (invoicesData && Array.isArray(invoicesData) && invoicesData.length > 0) ? (
  <GridComponent dataSource={invoicesData} allowPaging={true}>
  <ColumnsDirective>
    <ColumnDirective field="invoiceNumber" headerText="Invoice Number" width="200" textAlign="Center" />
    <ColumnDirective field="invoiceDate" headerText="Invoice Date" width="200" textAlign="Center" />
    
    <ColumnDirective
      field="costIncludingGstPay"
      headerText="Cost (Including GST)"
      width="200"
      textAlign="Center"
      template={(props) => `₹ ${props.costIncludingGstPay.toFixed(2)}`}
    />
    
    <ColumnDirective
      field="pendingAmount"
      headerText="Pending Amount"
      width="200"
      textAlign="Center"
      template={(props) => `₹ ${props.pendingAmount ? props.pendingAmount.toFixed(2) : "0.00"}`}
    />

    <ColumnDirective field="paymentStatus" headerText="Payment Status" width="150" textAlign="Center" />
    
    <ColumnDirective
      headerText="Action"
      width="150"
      textAlign="Center"
      template={(props) => (
        <button
          onClick={() => handleOpenPopup(props)}
          style={{
            padding: "5px 10px",
            backgroundColor: "#2196F3",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          Update Status
        </button>
      )}
    />
    
    <ColumnDirective
      headerText="Action"
      width="150"
      textAlign="Center"
      template={(props) => (
        <button
          onClick={() => handleDownloadInvoice(props)}
          style={{
            padding: "5px 10px",
            backgroundColor: "#4CAF50",
            color: "white",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          Download Invoice
        </button>
      )}
    />
  </ColumnsDirective>
</GridComponent>

        ) : (
          <p>No invoices found.</p>
        )}
  
        {showPopup && (
          <div
            style={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              backgroundColor: "white",
              padding: "20px",
              borderRadius: "8px",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
              zIndex: 1000,
              width: "300px",
            }}
          >
            <h3>Update Payment Status</h3>
            <p>Invoice Number: {selectedInvoice.invoiceNumber}</p>
            <select
              value={selectedStatus}
              onChange={(e) => setSelectedStatus(e.target.value)}
              style={{
                width: "100%",
                padding: "10px",
                marginBottom: "10px",
                borderRadius: "4px",
                border: "1px solid #ccc",
              }}
            >
              <option value="" disabled>
                Select Status
              </option>
              <option value="Online">Online</option>
              <option value="Pending">Pending</option>
              <option value="By Cash">By Cash</option>
            </select>
            
            <input
              type="number"
              placeholder="Enter Amount"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              style={{
                width: "100%",
                padding: "10px",
                marginBottom: "10px",
                borderRadius: "4px",
                border: "1px solid #ccc",
              }}
            />
            
            <input
              type="text"
              placeholder="Enter Transaction ID"
              value={transactionId}
              onChange={(e) => setTransactionId(e.target.value)}
              style={{
                width: "100%",
                padding: "10px",
                marginBottom: "20px",
                borderRadius: "4px",
                border: "1px solid #ccc",
              }}
            />
            
            <button
              onClick={handleStatusUpdate}
              style={{
                padding: "10px 20px",
                backgroundColor: "#4CAF50",
                color: "white",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
              }}
            >
              Update Status
            </button>
            <button
              onClick={() => setShowPopup(false)}
              style={{
                padding: "10px 20px",
                marginLeft: "10px",
                backgroundColor: "#f44336",
                color: "white",
                border: "none",
                borderRadius: "4px",
                cursor: "pointer",
              }}
            >
              Cancel
            </button>
          </div>
        )}
  
        {showPopup && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.3)",
              zIndex: 999,
            }}
            onClick={() => setShowPopup(false)} // Close popup on background click
          />
        )}
      </div>
    );
  };
  
  export default InvoicesPage;
  